/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from 'react-bootstrap/Button';
import clsx from 'clsx';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

function AdditionalTableDialog(props) {
  const {
    open,
    onOk,
    okTitle,
    onClose,
    closeTitle,
    modalTitle,
    className,
    viewAction,
    viewHeader,
    childrenComponent,
    removeClassName,
    dialogSpace,
    maxWidth = 'md',
  } = props;

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={maxWidth}
      className={clsx('multiGroupDialog custom-dialog-box', className)}
      data-testid="common-modal"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      {viewHeader && (
        <DialogTitle
          className="custom-panel p-0"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="panel-header">
            <span className="float-left">{modalTitle}</span>
            {onClose && (
              <span
                className="float-right"
                data-testid="searchExcluded"
                role="button"
                onClick={onClose}
              >
                <i className="fa fa-times-circle" aria-hidden="true" />
              </span>
            )}
            <div className="clearfix" />
          </div>
        </DialogTitle>
      )}
      <DialogContent
        style={viewHeader ? {} : { cursor: 'move' }}
        id={viewHeader ? '' : 'draggable-dialog-title'}
      >
        <div
          className={
            dialogSpace ? 'custom-panel' : 'custom-panel frr-modal-alignment'
          }
        >
          <div className="mui-custom-form">
            <div className={removeClassName ? '' : 'text-left'}>
              {childrenComponent}
            </div>
          </div>
        </div>
      </DialogContent>
      {viewAction && (
        <DialogActions className="justify-end">
          <div className="float-right">
            <div className="btn-wrapper my-2 mx-auto">
              <div className="float-right hide-on-print">
                {okTitle && (
                  <Button
                    onClick={onOk}
                    className="btn btn-success btn-search mr-2"
                    data-testid="filter-search-add-ndc-modal-add-btn"
                  >
                    <SVGComponent iconName="Icon_awesome-check-circle" />
                    {okTitle}
                  </Button>
                )}
                {closeTitle && (
                  <Button
                    onClick={onClose}
                    className="btn btn-cancel btn-primary mr-2"
                    data-testid="filter-search-add-ndc-modal-cancel-btn"
                    color="primary"
                    autoFocus
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    {closeTitle}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default AdditionalTableDialog;
